(function ($) {
  DJ.addBehavior('offer-slider', '.offer-block__slider', {
    attach: function (context, settings) {
      const $offerSlider = $(this);
      const $offerSliderItems = $offerSlider.find('.item');

      if ($offerSliderItems.length > 1) {
        $offerSlider.slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          speed: 500,
          fade: true,
          adaptiveHeight: true,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 5000,
        });
      }
    },
    detach: function (context, settings) {}
  });
})(jQuery);
